<template>
  <section class="payment-method-box">
    <bl-flex-container-mv class="pv-20 ph-16 gap-4" direction="column">
      <bl-flex-container-mv
        justify-content="space-between"
        align-items="center"
      >
        <bl-flex-item-av grow="1" shrink="1">
          <bl-text-av variation="body-16" weight="bold">
            Metode Pembayaran
          </bl-text-av>
        </bl-flex-item-av>
        <bl-flex-item-av v-if="balanceList.length > 1">
          <bl-link-av id="detail-button" @click="openBalanceDetailSheet">
            <bl-text-av variation="caption-12" color="link-01" weight="medium">
              Ubah
            </bl-text-av>
          </bl-link-av>
        </bl-flex-item-av>
      </bl-flex-container-mv>
      <bl-flex-container-mv class="gap-2" direction="column">
        <bl-flex-container-mv
          justify-content="space-between"
          align-items="center"
        >
          <bl-text-av :color="isBalanceSufficient ? 'primary' : 'subdued'">
            {{ paymentMethodName }}
          </bl-text-av>
          <bl-text-av v-if="isBalanceSufficient">
            {{ money(totalBalance) }}
          </bl-text-av>
        </bl-flex-container-mv>
        <bl-link-av
          v-if="!isBalanceSufficient && isCurrentBalanceActive"
          class="topup-button"
          @click="openTopupSaldoPage(paymentMethodType)"
        >
          <bl-text-av color="error-01">
            Klik di sini untuk tambah saldo
          </bl-text-av>
        </bl-link-av>
      </bl-flex-container-mv>
    </bl-flex-container-mv>
    <bl-sheet-mv
      id="detail-sheet"
      class="sheet-content"
      :active.sync="balanceDetailSheet"
      :auto-height="true"
      title="Pilih metode pembayaran"
    >
      <bl-flex-container-mv
        slot="content"
        class="sheet-content gap-2"
        direction="column"
      >
        <bl-flex-container-mv class="ph-16" direction="column">
          <bl-flex-container-mv
            v-for="(balance, iBalance) in balanceList"
            :key="iBalance"
            :class="getBalanceRowClass(iBalance)"
            align-items="center"
            wrap="wrap"
          >
            <bl-flex-item-av grow="1" shrink="1" basis="35%">
              <bl-radio-av
                v-model="internalPaymentMethodType"
                :native-value="balance.type"
                :disabled="shouldDisablePaymentMethod(balance)"
              >
                <bl-text-av
                  variation="body-16"
                  weight="bold"
                  :color="getBalanceTextColor(balance)"
                >
                  {{ balance.altName }}
                </bl-text-av>
              </bl-radio-av>
              <bl-text-av
                v-if="shouldShowSaldoMitraInsufficientMessage(balance)"
                class="ml-30 mt-8"
                color="error-01"
              >
                Saldo Mitra tidak cukup
              </bl-text-av>
              <template v-else-if="shouldShowTopupSaldoLink(balance)">
                <bl-link-av
                  class="ml-30 mt-8"
                  @click="openTopupSaldoPage(balance.type)"
                >
                  <bl-text-av class="ml-30 mt-8" color="error-01">
                    Klik di sini untuk tambah saldo
                  </bl-text-av>
                </bl-link-av>
              </template>
              <bl-text-av
                v-if="balance.state === walletStateFrozen"
                class="ml-30 mt-8"
                color="error-01"
              >
                Akun {{ balance.altName }} Anda sedang dibekukan. Silahkan
                hubungi BukaBantuan
              </bl-text-av>
            </bl-flex-item-av>
            <template v-if="balance.state === walletStateActive">
              <div>
                <bl-text-av variation="body-16" weight="bold">
                  {{ money(balance.balance) }}
                </bl-text-av>
              </div>
            </template>
            <template
              v-if="
                balance.name === 'BukaPay' && balance.state === walletStateError
              "
            >
              <bl-capsule-av variation="critical" size="small">
                Sedang Gangguan
              </bl-capsule-av>
            </template>
            <template
              v-if="
                balance.name === 'BukaPay' &&
                  balance.state === walletStateInactive
              "
            >
              <bl-capsule-av variation="critical" size="small">
                Belum aktif
              </bl-capsule-av>
              <bl-callout-mv
                class="mt-12"
                variation="low"
                style="flex-basis: 100%"
              >
                <bl-text-av variation="body-14" color="secondary">
                  Saldo Mitra akan ditutup dan beralih ke BukaPay. Aktifin
                  BukaPay kamu, ya.
                </bl-text-av>
                <bl-link-av @click="goToBukapayActivationPage">
                  Aktifkan saldo
                </bl-link-av>
              </bl-callout-mv>
            </template>
          </bl-flex-container-mv>
        </bl-flex-container-mv>
        <bl-button-av
          class="mh-16 mb-16"
          @click="choosePaymentMethodType(internalPaymentMethodType)"
        >
          Pilih
        </bl-button-av>
      </bl-flex-container-mv>
    </bl-sheet-mv>
  </section>
</template>
<script>
import BlTextAv from '@bukalapak/bazaar-mweb/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-mweb/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-mweb/dist/components/BlFlexItemAv';
import BlLinkAv from '@bukalapak/bazaar-mweb/dist/components/BlLinkAv';
import BlRadioAv from '@bukalapak/bazaar-mweb/dist/components/BlRadioAv';
import BlButtonAv from '@bukalapak/bazaar-mweb/dist/components/BlButtonAv';
import BlSheetMv from '@bukalapak/bazaar-mweb/dist/components/BlSheetMv';
import BlCapsuleAv from '@bukalapak/bazaar-mweb/dist/components/BlCapsuleAv';
import BlCalloutMv from '@bukalapak/bazaar-mweb/dist/components/BlCalloutMv';
import { mapGetters } from 'vuex';
import {
  PAYMENT_METHOD_TYPE_WALLET,
  PAYMENT_METHOD_TYPE_VJI_WALLET,
  PAYMENT_METHOD_NAME,
  BALANCE_STATE_ACTIVE,
  BALANCE_STATE_INACTIVE,
  BALANCE_STATE_FROZEN,
  BALANCE_STATE_ERROR,
} from 'shared_js/utils/buka20-constants';
import money from 'shared_js/helpers/stringHelper/money';
import { saldoTopupMixin } from '../mixins/transactionMixin';

export default {
  name: 'PaymentMethodBox',
  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlLinkAv,
    BlSheetMv,
    BlRadioAv,
    BlButtonAv,
    BlCapsuleAv,
    BlCalloutMv,
  },
  mixins: [saldoTopupMixin],
  props: {
    balanceList: {
      type: Array,
      required: true,
    },
    totalPrice: {
      type: Number,
      required: true,
    },
    paymentMethodType: {
      type: String,
      default: PAYMENT_METHOD_TYPE_WALLET,
    },
  },
  data() {
    return {
      balanceDetailSheet: false,
      internalPaymentMethodType: this.paymentMethodType,
      walletStateActive: BALANCE_STATE_ACTIVE,
      walletStateInactive: BALANCE_STATE_INACTIVE,
      walletStateFrozen: BALANCE_STATE_FROZEN,
      walletStateError: BALANCE_STATE_ERROR,
    };
  },
  computed: {
    ...mapGetters(['getDefaultPaymentMethodType', 'isWalletVjiEnabled']),
    totalBalance() {
      return this.currentBalance?.balance || 0;
    },
    currentBalance() {
      return this.balanceList.find(
        balance => balance.type === this.paymentMethodType,
      );
    },
    isCurrentBalanceActive() {
      return this.currentBalance?.state === this.walletStateActive;
    },
    isBalanceSufficient() {
      return this.totalBalance >= this.totalPrice;
    },
    paymentMethodName() {
      return PAYMENT_METHOD_NAME[this.paymentMethodType];
    },
  },
  watch: {
    isBalanceSufficient: {
      immediate: true,
      handler(newVal) {
        this.$emit('handleError', newVal);
      },
    },
  },
  mounted() {
    this.setDefaultPaymentMethod();
  },
  methods: {
    money,
    getBalanceTextColor(balance) {
      return balance.balance < this.totalPrice ? 'subdued' : 'primary';
    },
    shouldDisablePaymentMethod(balance) {
      const isUnboundBukapay =
        balance.type === PAYMENT_METHOD_TYPE_VJI_WALLET &&
        balance.state === BALANCE_STATE_INACTIVE;

      return isUnboundBukapay || balance.balance < this.totalPrice;
    },
    getBalanceRowClass(iBalance) {
      const borderClass =
        iBalance < this.balanceList.length - 1 ? 'border-bottom' : '';
      return `${borderClass} pv-24`.trim();
    },
    openBalanceDetailSheet() {
      this.internalPaymentMethodType = this.paymentMethodType;
      this.balanceDetailSheet = true;
      this.$emit('openDetail');
    },
    choosePaymentMethodType(paymentMethodType) {
      this.balanceDetailSheet = false;
      this.$emit('update:paymentMethodType', paymentMethodType);
    },
    getBalanceByType(paymentMethodType) {
      return this.balanceList.find(
        balance => balance.type === paymentMethodType,
      );
    },
    shouldShowSaldoMitraInsufficientMessage(balance) {
      return (
        this.isWalletVjiEnabled &&
        balance.type === PAYMENT_METHOD_TYPE_WALLET &&
        balance.state === this.walletStateActive &&
        balance.balance < this.totalPrice
      );
    },

    shouldShowTopupSaldoLink(balance) {
      if (this.isActiveBalanceSufficient(balance)) return false;
      if (this.shouldShowSaldoMitraInsufficientMessage(balance)) return false;

      if ([PAYMENT_METHOD_TYPE_VJI_WALLET].includes(balance.type)) {
        return balance.state === this.walletStateActive;
      }
      if (balance.type === PAYMENT_METHOD_TYPE_WALLET) {
        const vjiWallet = this.getBalanceByType(PAYMENT_METHOD_TYPE_VJI_WALLET);
        return vjiWallet?.state !== this.walletStateActive;
      }

      return true;
    },
    isActiveBalanceSufficient(balance) {
      return (
        balance?.state === BALANCE_STATE_ACTIVE &&
        balance.balance >= this.totalPrice
      );
    },
    resolveDefaultPaymentMethod(paymentMethod) {
      const walletBalance = this.getBalanceByType(PAYMENT_METHOD_TYPE_WALLET);
      const bukapayBalance = this.getBalanceByType(
        PAYMENT_METHOD_TYPE_VJI_WALLET,
      );
      const bukapayState = bukapayBalance?.state;

      // BukaPay is selectable when active, or whitelisted but not yet binded (inactive).
      if (
        bukapayState !== BALANCE_STATE_ACTIVE &&
        bukapayState !== BALANCE_STATE_INACTIVE
      ) {
        return paymentMethod;
      }

      if (!this.isActiveBalanceSufficient(walletBalance))
        return PAYMENT_METHOD_TYPE_VJI_WALLET;
      if (
        bukapayState === BALANCE_STATE_ACTIVE &&
        !this.isActiveBalanceSufficient(bukapayBalance)
      ) {
        return PAYMENT_METHOD_TYPE_WALLET;
      }

      return paymentMethod;
    },
    async setDefaultPaymentMethod() {
      await this.$store.dispatch('fetchPaymentConfigs');
      let paymentMethod = this.getDefaultPaymentMethodType;

      paymentMethod = this.resolveDefaultPaymentMethod(paymentMethod);

      this.internalPaymentMethodType = paymentMethod;
      this.$emit('update:paymentMethodType', paymentMethod);
    },
    goToBukapayActivationPage() {
      window.location.href = `${process.env.MITRA_BUKALAPAK_BASE_URL}/profile`;
    },
  },
};
</script>

<style lang="scss" scoped>
.gap-1 {
  gap: 4px;
}
.gap-2 {
  gap: 8px;
}
.gap-4 {
  gap: 16px;
}

.ml-30 {
  margin-left: 30px;
}

.border-bottom {
  border-bottom: 1px solid #eee;
}
</style>
